export default __webpack_public_path__ + "static/media/treat-yourself-480w.e3d70751.webp";